import template from './documentAdd.template.html';

export default {
  bindings: {
    isCompliance: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $mdDialog,
      $mdMedia,
      eventService,
      documentService,
      uiService,
      Document,
      DOCUMENT
    ) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.queue = [];
      ctrl.documents = [];
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onDocumentAdd(function (_params) {
          const documentAdd = function (document) {
            return documentService.createDocument(document).then(function (data) {
              if (data.status) {
                const index = _.findIndex(ctrl.documents, function (d) {
                  return d.file === document.file;
                });
                ctrl.documents[index].id = data.id;
                ctrl.documents[index].isNew = true;
              }
            });
          };

          function dialogController($mdDialog, ticketId) {
            this.url = DOCUMENT.API.UPLOAD;
            this.allowMultiple = DOCUMENT.LIMITS.MULTIPLE;
            this.allowedMimeTypes = DOCUMENT.LIMITS.ALLOWED_MIME;
            this.allowedExtensions = DOCUMENT.LIMITS.ALLOWED_EXTENSIONS;
            this.ticketId = ticketId;
            this.startUpload = false;
            this.uploadFinished = function (files) {
              $mdDialog.hide(files);
            };
            this.confirm = function () {
              this.startUpload = true;
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }

          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                ticketId: _params.ticketId
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (files) {
              ctrl.queue = [];
              ctrl.documents = [];
              let len = files.length;
              while (len--) {
                const document = Document.build(files[len]);
                document.isCompliance = ctrl.isCompliance;
                ctrl.queue.push(documentAdd(document));
                ctrl.documents.push(document);
              }
              $q.all(ctrl.queue).then(function () {
                ctrl.onFinished({ documents: ctrl.documents });
                uiService.toast({
                  text: {
                    p1: files.length > 1 ? ctrl.documents.length : 'Document',
                    p2: files.length > 1 ? 'documents' : ctrl.documents[0].getName(),
                    p3: `${files.length > 1 ? 'have' : 'has'} been added`
                  }
                });
              });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
